export default {"id":"b3d8e0ad","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}